import { getSomeDaysAgo } from "@/helpers";

export const today = new Date(new Date().setHours(0, 0, 0, 0));

export const dateRangesOverride =  [
      {
        title: 'Today',
        alias: 'today',
        period: {
          since: today,
          until: today,
        },
      },
      {
        title: 'Tomorrow',
        alias: 'tomorrow',
        period: {
          since: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),
          until: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),
        },
      },
      {
        title: 'This week',
        alias: 'thisWeek',
        period: {
          since: new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay()),
          until: new Date(today.getFullYear(), today.getMonth(), today.getDate() + (6 - today.getDay())),
        },
      },
      {
        title: 'Next week',
        alias: 'nextWeek',
        period: {
          since: new Date(today.getFullYear(), today.getMonth(), today.getDate() + (7 - today.getDay())),
          until: new Date(today.getFullYear(), today.getMonth(), today.getDate() + (13 - today.getDay())),
        },
      },
      {
        title: 'This month',
        alias: 'thisMonth',
        period: {
          since: new Date(today.getFullYear(), today.getMonth(), 1),
          until: new Date(today.getFullYear(), today.getMonth() + 1, 0),
        },
      },
      {
        title: 'Next month',
        alias: 'nextMonth',
        period: {
          since: new Date(today.getFullYear(), today.getMonth() + 1, 1),
          until: new Date(today.getFullYear(), today.getMonth() + 2, 0),
        },
      },
]

export const dateRangesDashboard = [
    {
        title: 'Today',
        alias: 'today',
        period: {
          since: today,
          until: today,
        },
    },
    {
        title: 'Last 7 days',
        alias: 'last7Days',
        period: {
          since: new Date(getSomeDaysAgo(7)),
          until: new Date(getSomeDaysAgo(1)),
        },
    },
    {
        title: 'Last 30 days',
        alias: 'last30Days',
        period: {
          since: new Date(getSomeDaysAgo(30)),
          until: new Date(getSomeDaysAgo(1)),
        },
    },
]